export function balancedColumnCount(
  itemCount: number,
  maxColumns: number,
): number {
  if (itemCount <= maxColumns) return maxColumns;
  const rowCount = Math.ceil(itemCount / maxColumns);
  return Math.ceil(itemCount / rowCount);
}

/**
 * 1枚のカードが2トラックを占める `maxColumns * 2` トラックのグリッドで、
 * 各行を中央寄せにするための行頭カードの開始トラック（1始まり）を返す。
 * 行頭でないカードには `undefined` を返す。
 */
export function centeredRowStartTrack(
  index: number,
  itemCount: number,
  maxColumns: number,
): number | undefined {
  const columnCount = balancedColumnCount(itemCount, maxColumns);
  if (index % columnCount !== 0) return undefined;
  const rowItemCount = Math.min(columnCount, itemCount - index);
  return maxColumns - rowItemCount + 1;
}
